import { useEffect } from 'react';

export const HOME_REDIRECT_URL = 'https://beremarkable.ai';

type ExternalRedirectProps = {
  to: string;
};

/** Browser-level redirect for unknown / home routes. */
function ExternalRedirect({ to }: ExternalRedirectProps) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return (
    <div className="min-h-screen bg-primary-gray flex items-center justify-center px-6">
      <p className="text-sm text-gray-600 font-fustat">Redirecting…</p>
    </div>
  );
}

export default ExternalRedirect;
